export default __webpack_public_path__ + "static/media/04_labVisitTracker.717562d7.png";